import React from "react";
import { Theme, ThemeContextType } from "../libs/Interfaces";

const ThemeContext = React.createContext<ThemeContextType>({
    setTheme: (theme: Theme) => console.log(theme),
    getTheme: "DARK",
    statusBar: (color: string) => console.log(color)
});

export function useTheme() {
    return React.useContext(ThemeContext);
}

export function ThemeProvider({ children }: { children: any }) {

    const [theme, setTheme] = React.useState<Theme>("DARK");
    const [status, setStatus] = React.useState("#333333");

    function statusBar(color: string) {
        if (color === status) return;
        let meta = document.getElementsByName("theme-color")[0];
        if (meta) {
            meta.setAttribute("content", color);
        }
        setStatus(color);
    };

    const value: ThemeContextType = {
        setTheme,
        getTheme: theme,
        statusBar
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
}